import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import {
  DEFAULT_CUSTOMERS_LIST_FILTERS,
  GROUPS_LIST_PAGINATION,
} from "./Customers.constants";

export const initialState = {
    loading: true,
    error: null,
    customers: [],
    customersList: [],
    selectedCustomer: null,
    selectedView: INFRAMARK_CONSTANTS.groups.constants.GROUPLISTVIEW,
    listFilters: { ...DEFAULT_CUSTOMERS_LIST_FILTERS },
    pagination: {
      page: GROUPS_LIST_PAGINATION.DEFAULT_PAGE,
      size: GROUPS_LIST_PAGINATION.DEFAULT_PAGE_SIZE,
      totalCount: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
    },
}
